import { RefObject } from "react";
import { V1Clinic } from "../types/v1_schemas";
import { DivIcon, LatLngLiteral } from "leaflet";
import { latLngBounds, Map } from "leaflet";

export const getMapMarker = (
  result: V1Clinic | undefined,
  selectedResultId: string | undefined = undefined
) => {
  const markerClass =
    selectedResultId === result?.accountId
      ? "custom-map-marker-active"
      : "custom-map-marker";
  const markerNumber = result && "searchRank" in result ? result.searchRank : "";
  const ariaLabel = markerNumber
    ? `${markerNumber}. ${result?.displayName}`
    : result?.displayName;
  const markerHtml = `<div class='map-marker-pin' aria-label='${ariaLabel}' role='button'><div class='map-marker-text'>${markerNumber}</div></div>`;
  const marker = new DivIcon({
    className: markerClass,
    html: markerHtml,
    iconSize: [32, 32],
    iconAnchor: [16, 46], // adjusts icon placement so that the pin point sits on the latlong location
  });
  return marker;
};

export const rerenderMap = (
  mapRef: RefObject<Map>,
  results: V1Clinic[]
) => {
  setTimeout(() => {
    mapRef.current?.invalidateSize();
    const bounds = getResultBounds(results);
    bounds &&
      mapRef.current?.fitBounds(bounds, { animate: false, padding: [50, 50] });
  }, 100);
};

/**
 * Helper function to get bounds for the search result map
 * based on the returned set of CareProviderSearchResults.
 * If none of the care providers have latlng data, then the
 * bounds are set based on points pulled from the northwestern
 * and southeastern most points in CO.
 * @param searchResults
 * @returns
 */

export const getLatLng = (latitude:string, longitude: string): LatLngLiteral | null => {
  const lat = parseFloat(latitude);
  const lng = parseFloat(longitude);
  if (!!(lat && lng)) {
    return { lat, lng };
  }

  return null;
};

export function getResultBounds(searchResults: V1Clinic[]) {
  const latLngs = searchResults
  .map((result) => result.latLng)
  .filter((latLng): latLng is LatLngLiteral => !!latLng);

return latLngs.length ? latLngBounds(latLngs) : undefined;

}

export const CO_CENTER = { lat: 39.113014, lng: -105.358887 };

export function populateSearchRankLatLng(
  clinicList: V1Clinic[],
  pageNumber: number,
  pageSize: number
): any {
  if (clinicList && clinicList.length && clinicList.length > 0) {

    // populate searchRank for index value and map
    for (let i = 0; i < clinicList.length; i++) {
      
      clinicList[i].searchRank = i + ((pageNumber - 1) * pageSize + 1);

      // populate latLng for map and offersTelehealth
      const location = clinicList[i].clinicLocations?.find(
        (item) =>
          (item.addrTypeText === "Primary Address" || item.addrTypeText === "Dirección principal") &&
          item.latitude &&
          item.latitude.length > 0 &&
          item.longitude &&
          item.longitude.length > 0
      );
      
      // on first pass through, populate v1Clinic.latLng and telehealth if true
      if (location) {
        clinicList[i].latLng = getLatLng(
          location.latitude ?? "",
          location.longitude ?? ""
        ) as LatLngLiteral;
      } else {
//        clinicList[i].offersTelehealth = true;
      }
    }
  }
  return clinicList;
}